import React, {useState, useEffect, useRef, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Pagination, Spin} from 'antd';
import {searchConsPageByIntercept, searchPage} from '@/api/conversation';
import ContentCard from './ContentCard';
import styles from './card.module.less';
import _ from 'lodash';

function Content({receiveType, from, receive, currentPage, size = 5}) {
    const userDetailRef = useRef();
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(0);
    const [contents, setContents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [preMsgId, setPreMsgId] = useState([]);

    useEffect(() => {
        setLoading(true);
        if (!_.isEmpty(from)) {
            setCurrent(currentPage);
            initData(currentPage);
        } else {
            // setContents([]);
            // setTotal(0);
            // setCurrent(1);
            // setLoading(false);
        }
    }, []);

    function initData(currentPage) {
        let to = '';
        let fromId = '';
        let chatId = '';
        if (receiveType !== 3) {
            fromId = from.extId;
            to = receiveType === 1 ? receive.externalUserId : receive.extId;
        } else chatId = receive.chatId;
        let searchParam = {
            to: to,
            from: fromId,
            type: 1,
            roomid: chatId,
            page: currentPage,
            size: size,
        };
        searchConsPageByIntercept(searchParam).then(res => {
            if (!_.isEmpty(res.data) && res.data.records.length > 0) {
                setTotal(res.data.total);
                setCurrent(res.data.current);
                setLoading(false);
                /**
                 * 查询结果需要做特殊处理,撤回消息 要找到撤回的内容 语音会议要要找到对应的分配
                 */
                let resData = [];
                let pre = [...preMsgId];
                let tempDoc = [];
                for (let i = 0; i < res.data.records.length; i++) {
                    const val = res.data.records[i];
                    const type = val.msgtype;
                    if (pre.includes(val.msgid)) {
                        continue;
                    }
                    if (type === 'revoke') {
                        // 撤回消息
                        val.premsg = res.data.records[i + 1];
                        pre.push(res.data.records[i + 1].msgid);
                    }
                    if (type === 'voip_doc_share') {
                        // 语音会议分享消息
                        tempDoc.push(val);
                        continue;
                    }
                    if (type === 'text' && val.text.content === '【未知消息类型】') {
                        // 语音会议分享消息中的杂项
                        continue;
                    }
                    resData.push(val);
                }
                // 额外需要对语音会议及docshare文件进行合并
                let finalData = [];
                resData.forEach(item => {
                    const msgtype = item.msgtype;
                    if (msgtype === 'meeting_voice_call') {
                        const {voiceid} = item;
                        const docShare = tempDoc.filter(v => v.voipid === voiceid);
                        item.docShare = docShare;
                    }
                    finalData.push(item);
                });
                console.log('final', finalData);
                setContents([...finalData]);
                setPreMsgId(pre);
            } else {
                setTotal(0);
                setCurrent(1);
                setContents([]);
                setLoading(false);
            }
            setLoading(false);
        });
    }

    function changePage(page, size) {
        setLoading(true);
        setContents([]);
        setCurrent(page);
        initData(page);
    }

    function openDetail(userDetail) {
        userDetailRef.current.open(userDetail);
    }

    function renderContents() {
        return (
            <div className={styles.container}>
                {contents.length > 0 &&
                    contents.map((content, key) => (
                        <ContentCard
                            openDetail={receiveType === 3 ? openDetail : () => {}}
                            key={key}
                            content={content}
                            from={from}
                            fromType={0}
                            receive={
                                receiveType === 3
                                    ? !_.isEmpty(receive.memberList) &&
                                      receive.memberList.find(item => item.extId === content.from)
                                    : receive
                            }
                        />
                    ))}
            </div>
        );
    }

    return (
        <div style={{background: '#F8F8F8'}}>
            {<Spin spinning={loading}>{renderContents()}</Spin>}
            <div className={styles.page}>
                <Pagination
                    defaultCurrent={1}
                    defaultPageSize={size}
                    total={total}
                    current={current}
                    onChange={changePage}
                    hideOnSinglePage={true}
                />
            </div>
        </div>
    );
}

Content.propTypes = {
    receiveType: PropTypes.number,
    receive: PropTypes.object,
    from: PropTypes.object,
    currentPage: PropTypes.number,
    size: PropTypes.number,
};

export default Content;
